module.exports = __webpack_public_path__ + "static/media/komf1.f082b5c3.jpg";